import styled from 'styled-components';
import Select from 'react-select';

type QuantityPickerProps = {
  isCartTransparencyTestOn: boolean;
};

export const QuantityPickerLabel = styled.div`
  font-family: 'Crimson Text';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  padding-bottom: 4px;
`;

export const StyledQuantityPicker = styled(Select)<QuantityPickerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #707070;
  border-radius: ${(props) => (props.isCartTransparencyTestOn ? '0px' : '500px')};
`;

export const QuantityValue = styled.select`
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
  font-size: 0.85rem;
  font: inherit;
`;
